import React from "react";

/**
 * Renders a lineage tree iteratively (DFS into a flat array of rows).
 * Avoids recursive JSX which triggers a known Babel/fast-refresh stack
 * overflow when the recursive component lives in the same module graph.
 */
function flatten(root, depth, out) {
  if (!root) return;
  out.push({ node: root, depth });
  const kids = root.children || [];
  for (let i = 0; i < kids.length; i++) flatten(kids[i], depth + 1, out);
}

export default function LineageNode({ node, depth = 0 }) {
  const rows = [];
  flatten(node, depth, rows);
  return (
    <div className="space-y-1.5 mt-1">
      {rows.map((r, idx) => (
        <div key={`${r.node.id}-${idx}`} style={{ marginLeft: r.depth * 18 }}>
          <a href={`/profile/${r.node.id}`} className="inline-flex items-center gap-2 text-foreground/85 hover:text-secondary">
            <span className="text-foreground/30 font-mono">{r.depth === 0 ? "\u25C6" : "\u2514"}</span>
            <span className="font-serif">{r.node.name}</span>
            {r.node.profile && r.node.profile.tradition ? (
              <span className="text-xs text-foreground/45 italic">- {r.node.profile.tradition}</span>
            ) : null}
            {r.node.profile && r.node.profile.verifiedTier && r.node.profile.verifiedTier !== "none" ? (
              <span className="text-[10px] text-primary uppercase tracking-wider">{r.node.profile.verifiedTier}</span>
            ) : null}
          </a>
        </div>
      ))}
    </div>
  );
}
